import type { CallbackFunction, JSBridgeInterface } from '@docoi/jsbridge-sdk/types';
import JSBridgeSdk, { type MethodHandler } from '@docoi/jsbridge-sdk';
// 导入类型定义以启用类型提示
import type { TypeSafeJSBridgeInterface } from './types';
import { isTestEnv } from '../utils/env';

// 导入 JSBridge SDK

let originalJSBridge: JSBridgeInterface;

let testEnv = isTestEnv();
// 初始化 JSBridge
const options = {
  debug: testEnv,
  timeout: 3000, // 默认超时时间 3s
  enableCache: false
};

// 初始化 JSBridge
originalJSBridge = JSBridgeSdk.init(options);
if (testEnv) {
  originalJSBridge.setDebug(true, {
    logLevel: 'debug'
  });
}

// 创建类型安全的 JSBridge 包装器，覆盖原始类型定义
const createTypeSafeJSBridge = (original: JSBridgeInterface): TypeSafeJSBridgeInterface => {
  return original as unknown as TypeSafeJSBridgeInterface;
};

// 创建类型安全的 JSBridge 实例
const JSBridge = createTypeSafeJSBridge(originalJSBridge);

// 导出类型安全的 JSBridge 实例
export default JSBridge;

// 导出类型定义
export type {
  JSBridgeMethodsMap,
  JSBridgeEventsMap,
  TypeSafeJSBridgeInterface,
  JSBridgePermissionType,
  JSBridgePermissionResultType,
  IJSBridgeCheckPermissionParams,
  IJSBridgeCheckPermissionResult
} from './types';

// 重新导出原有类型
export type { CallbackFunction, JSBridgeInterface, MethodHandler };
